import React, { useState, useEffect } from "react";
import firebase from "../../firebase";
import "react-datepicker/dist/react-datepicker.css";

import Service from "../../Service/firebase";
import NewServiceForm from "./newsubcategoryform";

import "./addsubcategory.css";

const AddService = (props) => {
  // lockedVendorId is passed for vendor roles — bypasses vendorCode lookup
  const isVendorLocked = !!props.lockedVendorId;
  const [imageFile, setImageFile] = useState(null);
  const [htmlElement, setHtmlElement] = useState(
    <i className="fa fa-image fa-8x" aria-hidden="true"></i>
  );
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [formData, setFormData] = useState({
    serviceName: "",
    categoryId: "",
    categoryName: "",
    group: "",
    gender: "",
    actualPrice: "",
    offerPrice: "",
    serviceTime: "",
    description: "",
    image: "",
    isActive: true,
    isPackage: false,
    vendorCode: props.defaultVendorCode || "",
    vendorId: "",
  });

  useEffect(() => {
    onFetchData();
  }, []);

  const onFetchData = async () => {
    const fetchedCategories = await Service.getAllData("category");
    const fetchedVendors = await Service.getAllData("vendors");

    if (fetchedCategories.length > 0) setCategories(fetchedCategories);
    if (fetchedVendors.length > 0) setVendors(fetchedVendors);
  };

  const onAddService = async (imageUrl) => {
    let resolvedVendorId;

    if (isVendorLocked) {
      resolvedVendorId = props.lockedVendorId;
    } else {
      const selectedVendor = vendors.find((v) => v.vendorCode === formData.vendorCode);
      if (!selectedVendor) {
        setIsLoading(false);
        props.handleErrorDailog();
        return;
      }
      resolvedVendorId = selectedVendor.uid;
    }

    const { vendorCode, ...rest } = formData;
    const sendData = {
      ...rest,
      vendorId: resolvedVendorId,
      searchbyname: formData.serviceName.toLowerCase().replace(/\s/g, ""),
      image: imageUrl,
      createdTime: firebase.firestore.Timestamp.fromDate(new Date()),
    };

    const res = await Service.addData(sendData, "services", "serviceId");

    if (res === "success") {
      // update vendor record only if accessed by org admin (not vendor role)
      if (!isVendorLocked) {
        const selectedVendor = vendors.find((v) => v.uid === resolvedVendorId);
        if (selectedVendor && !selectedVendor.services) {
          await Service.updateData({ services: true }, "vendors", resolvedVendorId);
        }
      }
      setIsLoading(false);
      props.handleSuccessDailog();
    } else {
      setIsLoading(false);
      props.handleErrorDailog();
    }
  };

  const handleImageForUpload = () => {
    if (imageFile !== null) {
      onUploadImage(imageFile);
    } else {
      onAddService("");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    handleImageForUpload();
  };

  const onUploadImage = async (image) => {
    const url = await Service.uploadImage(image, "servicesImages");
    if (url !== "") {
      onAddService(url);
    }
  };

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImageFile(event.target.files[0]);
      let reader = new FileReader();
      reader.onload = (e) => {
        setHtmlElement(
          <div className="addpersonpage">
            <img className="netimage" srcSet={e.target.result} alt="serviceImage" />
          </div>
        );
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const onImageRemove = () => {
    setImageFile(null);
    setHtmlElement(
      <div className="addpersonpage">
        <i className="fa fa-image fa-8x" aria-hidden="true"></i>
      </div>
    );
  };

  const onEdit = (e) => {
    const { name, value, type, checked } = e.target;
    let updatedFormData = {
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    };

    if (name === "categoryId" && value) {
      const selectedCategory = categories.find((cat) => cat.categoryId === value);
      if (selectedCategory) {
        updatedFormData.categoryName = selectedCategory.name;
      }
      // reset group when category changes
      updatedFormData.group = "";
    }

    setFormData(updatedFormData);
  };

  const handleCancel = () => {
    props.handleErrorDailog();
  };

  return isLoading ? (
    <div className="addpersonpage">
      <i className="fas fa-spinner fa-pulse fa-2x"></i>
    </div>
  ) : (
    <div className="addpersonpage">
      <div className="container main_section">
        <div className="row">
          <div className="col-sm">
            <NewServiceForm
              handleSubmit={handleSubmit}
              onEdit={onEdit}
              htmlelement={htmlElement}
              onImageRemove={onImageRemove}
              onImageChange={onImageChange}
              onCancel={handleCancel}
              defaultVendorCode={props.defaultVendorCode || ""}
              isVendorLocked={isVendorLocked}
            ></NewServiceForm>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddService;
